<div class="form-group full-width" [ngClass]="{ 'has-error': control?.invalid, required: required }">
  <label *ngIf="label" [attr.for]="id">{{ label }}</label>
  <xux-hint [description]="description" container="body" placement="auto"></xux-hint>
  <input
    #inputElement
    class="{{ class }}"
    [attr.id]="id"
    [attr.name]="name"
    [attr.type]="'number'"
    [attr.step]="step"
    [attr.placeholder]="placeholder"
    [formControl]="userControl"
    [attr.required]="required ? 'true' : null"
    [attr.disabled]="disabled ? 'true' : null"
    [attr.data-integration-id]="'input-number'"
    (keydown)="onKeyDown($event)"
    (input)="onNumberChanged($event)"
    (wheel)="handleScroll($event)"
    (focusout)="markControlAsTouched()"
  />
  <xvi-error-block [control]="control"></xvi-error-block>
</div>
